import React from 'react';
import styled from 'styled-components/macro';
import ReactSlider from 'react-slider';
import { useTheme } from 'styled-components';

const StyledSlider = styled(ReactSlider)`
  width: 100%;
  height: 8px;
`;

const StyledThumb = styled.div<any>`
  height: 16px;
  width: 16px;
  margin-top: -4px;
  text-align: center;
  background-color: white;
  color: #fff;
  border-radius: 50%;
  cursor: grab;
`;

const StyledTrack = styled.div<any>`
  top: 0;
  bottom: 0;
  background-color: ${props => props.colors.highlight};
  border-radius: 999px;

  &:nth-child(2) {
    background-color: white;
    opacity: .5;
  }
`;

const Slider = (props) => {
  const { colors } = useTheme();

  const Thumb = props => <StyledThumb {...props} colors={colors} />;
  const Track = (props, state) => <StyledTrack {...props} colors={colors} index={state.index} />;

  return (
    <StyledSlider
      {...props}
      colors={colors}
      renderTrack={Track}
      renderThumb={Thumb}
    />
  );
};

export default Slider;
